// -- shipment -- //
export const FROM_INSTANTPRICE = 0;
export const FROM_RFQ = 1;
export const FROM_CONTRACT = 2;
export const FROM_INSTANTQUOTE = 3;

export const FREIGHT_AIR = 'AIR';
export const FREIGHT_OCEAN = 'OCEAN';
export const FREIGHT_LAND = 'LAND';

export const SHIPMENT_AIRCARGO = 'AIRCARGO';
export const SHIPMENT_AIRCOURIER = 'AIRCOURIER';
export const SHIPMENT_AIRBREAKBULK = 'AIRBREAKBULK';
export const SHIPMENT_FCL = 'FCL';
export const SHIPMENT_LCL = 'LCL';
export const SHIPMENT_SEABREAKBULK = 'BREAKBULK';
export const SHIPMENT_BARGE = 'BARGE';
export const SHIPMENT_LCT = 'LCT';

export const PRODUCT_GENCO = 'GENCO';
export const PRODUCT_SC = 'SC';
export const PRODUCT_DG = 'DG';

// -- shipping -- /
export const SERVICE_PORT_TO_PORT = 'ptp';
export const SERVICE_DOOR_TO_PORT = 'dtp';
export const SERVICE_DOOR_TO_DOOR = 'dtd';
export const SERVICE_PORT_TO_DOOR = 'ptd';

// -- otif -- /
export const OTIF_BOOKED = 'BOOKED';
export const OTIF_SCHEDULED = 'SCHEDULED_OTIF';
export const OTIF_PICKUP = 'PICKUP';
export const OTIF_OLC = 'ORIGIN_LOCAL_HANDLING';
export const OTIF_DLC = 'DESTINATION_LOCAL_HANDLING';
export const OTIF_ARRIVAL = 'ARRIVAL';
export const OTIF_DEPARTURE = 'DEPARTURE';
export const OTIF_DELIVERY = 'DELIVERY';
export const OTIF_COMPLETED = 'COMPLETED_OTIF';
export const OTIF_REJECTED = 'REJECTED';
export const OTIF_CANCELED = 'CANCELLED';
export const OTIF_DELAY = 'DELAY';
// -- otif truck management system TMS --
export const OTIF_STARTED = 'STARTED';
export const OTIF_LOADING = 'LOADING';
export const OTIF_INTRANSIT = 'INTRANSIT';
export const OTIF_UNLOADING = 'UNLOADING';
export const OTIF_DELIVERED = 'DELIVERED';

export const SHIPMENT_SERVICE = [
  { id: 1, text: 'Door to Door', value: 'dtd' },
  { id: 2, text: 'Door to Port', value: 'dtp' },
  { id: 3, text: 'Port to Port', value: 'ptp' },
  { id: 4, text: 'Port to Door', value: 'ptd' }
];



// WEBPACK FOOTER //
// ./src/constant/shipment-details.js